import { LIST_FORM_IDXPATH } from './sharePointListForm.constants';
import {
    getListFormNodeValue,
    selectListFormNodes,
} from './sharePointListForm.getDsFieldValues';
import { createFieldItem } from './sharePointListForm.getFieldValues';

const excludedFields = [
    'author',
    'editor',
    'modified',
    'created',
    'attachments',
];
const excludedTypes = ['calculated'];

function createItemContainer(siteUrl, listId, listName, listItems, fieldsDef) {
    const itemArray = listItems.map((itemNode) => ({
        Id: getListFormNodeValue(itemNode, LIST_FORM_IDXPATH),
        node: {
            node: itemNode,
        },
        fieldArray: fieldsDef.map((field) => createFieldItem(itemNode, field)),
    }));

    return {
        itemArray,
        siteUrl,
        listId,
        listName,
        useName: !!listName,
    };
}

const canUpdateField = (field) =>
    excludedFields.indexOf(field.internalName.toLowerCase()) === -1 &&
    excludedTypes.indexOf(field.type.toLowerCase()) === -1;

export function getItemContainer(
    siteUrl,
    listId,
    listName,
    dataSources,
    fields,
) {
    const dataSource = dataSources.getDom('');
    const listItems = selectListFormNodes(
        dataSource,
        'dfs:myFields/dfs:dataFields/my:SharePointListItem_RW',
    );
    const fieldsDef = fields.filter(canUpdateField);

    const itemContainer = createItemContainer(
        siteUrl,
        listId,
        listName,
        listItems,
        fieldsDef,
    );

    return itemContainer;
}
